import Navbar from "./Navbar";
import Footer from "./Footer";
import BottomNav from "./BottomNav";
import { Toaster } from "sonner";
import { useLocation } from "react-router-dom";
import { useLang } from "@/context/LanguageContext";
import { useTheme } from "@/context/ThemeContext";

export default function Layout({ children }) {
  const { t } = useLang();
  const { theme } = useTheme();
  const { pathname } = useLocation();

  // /karte-embed: Vollbild-Karte für die native App (WebView) — NUR der
  // Karteninhalt, kein globales Chrome (Navbar/Footer/BottomNav/Toaster).
  // Die App zeigt ihre eigene Navigation um den WebView herum.
  if (pathname === "/karte-embed") {
    return <main id="main-content">{children}</main>;
  }

  // Inseratsseiten bringen mobil ihre EIGENE untere Leiste mit (PropertyDetail,
  // mobile-contact-bar: WhatsApp/Anruf/Kontakt). Die freischwebende Nav-Kapsel
  // lag mit z-50 exakt darüber — ein Tipp auf „Kontakt" traf die Navigation
  // und landete auf /pakete (Walkthrough-Fund 19.08.2026). Auf diesen Seiten
  // weicht die Kapsel; zurück führt der Zurück-Knopf der Seite (alle Breiten).
  // pathname ist dank Router-basename bereits ohne Sprachpräfix.
  // Seit 01.10.2026 auch die geöffnete Unterhaltung: Sie liegt am Handy als
  // Vollbild mit Eingabezeile unten (Messages.jsx) — wie in der App ohne
  // Tab-Leiste. Am Tablet/Desktop blendet die Kapsel ohnehin aus (md:hidden).
  const eigeneUntereLeiste = pathname.startsWith("/immobilie/") || pathname.startsWith("/nachrichten/");

  return (
    // Handy: App-Seitengrund (reines Weiß bzw. #121212, mobile/theme/colors.ts
    // → background); ab md der Sand wie bisher.
    <div className="min-h-screen bg-appbg md:bg-sand text-anthracite flex flex-col">
      {/* Skip-Link: sichtbar erst bei Tastatur-Fokus (sr-only + focus:not-sr-only) —
          erspart Screenreader-/Tastaturnutzern das Durchtabben von Navbar + Sprachwahl. */}
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:absolute focus:z-[100] focus:top-3 focus:start-3 focus:px-4 focus:py-2 focus:rounded-full focus:bg-inkchip focus:text-white focus:text-sm focus:shadow-lg"
      >
        {t("nav.skip")}
      </a>
      <Navbar />
      <main id="main-content" className="flex-1">{children}</main>
      <Footer />
      {/* Die freischwebende Bottom-Nav-Kapsel liegt fixiert über dem Inhalt (nur
          mobil) — dieser Platzhalter hält den Fuß des Footers frei. Höhe wie
          in der App (useTabBarClearance: 76 + Safe-Area): Kapsel ~52px +
          Bodenabstand 8px + Luft. */}
      {!eigeneUntereLeiste && (
        <div className="md:hidden h-[calc(76px+env(safe-area-inset-bottom))]" aria-hidden="true" />
      )}
      {!eigeneUntereLeiste && <BottomNav />}
      {/* theme aus dem ThemeContext — sonst blieben die Toasts im Dark Mode weiß. */}
      <Toaster position="top-right" richColors theme={theme} />
    </div>
  );
}
